import * as Long from "long";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IdResource } from "../../../../constants/IdResource";
import { selectInventoryResourceInfo } from "../../../../selectors/selectInventoryInfo";
import { actionBeginBuyWithGoldProcess } from "../../../buy-with-gold/actionBuyWithGold";
import { actionExpansionConfirmBuyPremium, TypeActionExpansions, } from "../actionExpansions";
export var epicExpansionBuyPremium = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionExpansions.RequestBuyPremium), switchMap(function (action) {
        var state = state$.value;
        var playerGoldInfo = selectInventoryResourceInfo(state, IdResource.Gold).amount || Long.ZERO;
        var expansionId = action.expansionId, goldAmount = action.goldAmount;
        var onConfirm = actionExpansionConfirmBuyPremium(expansionId, goldAmount);
        return of(actionBeginBuyWithGoldProcess(playerGoldInfo, goldAmount, onConfirm));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/epics/epicExpansionBuyPremium.ts
// module id = 2095
// module chunks = 3